import {
  canOpenNetworkMemberProfile,
  fetchIsNecCouncilMember,
  NEC_COUNCIL_NAME,
} from "../../../utils/necMembership";

const DASTAK_HOME_ROUTE = "/dastak/homepage";
const CONTACT_ADMIN_ROUTE = "/contact-admin";
const ACCESS_DENIED_ROUTE = "/coming-soon";

const hasSuperUserPermission = (permissionsPayload) => {
  const permissions = permissionsPayload?.permissions || permissionsPayload;

  return Boolean(
    permissionsPayload?.isSuperUser ||
      permissions?.isSuperUser ||
      permissions?.["*"]?.["*"]?.["*"] ||
      permissions?.permissions?.["*"]?.["*"]?.["*"],
  );
};

const hasPolicyRoleFromPermissions = (permissionsPayload) => (role) => {
  const scopes = Array.isArray(permissionsPayload?.scopes)
    ? permissionsPayload.scopes
    : Array.isArray(permissionsPayload?.permissions?.scopes)
      ? permissionsPayload.permissions.scopes
      : [];

  const targetRole = String(role || "").trim().toUpperCase();

  return scopes.some((scope) => {
    const pRole = String(
      scope?.designation?.policyRole ||
        scope?.designation?.designationKey ||
        scope?.policyRole ||
        scope?.designationKey ||
        ""
    )
      .trim()
      .toUpperCase();
    return pRole === targetRole;
  });
};


export const resolvePostOtpRoute = (userData, postLoginRedirectRoute = "") => {
  if (!userData) return CONTACT_ADMIN_ROUTE;

  const verifiedStatus = String(userData?.verified || "").toLowerCase();
  if (!verifiedStatus || verifiedStatus === "false") return "/registerNewUser";
  if (verifiedStatus === "pending") {
    return postLoginRedirectRoute === DASTAK_HOME_ROUTE
      ? DASTAK_HOME_ROUTE
      : CONTACT_ADMIN_ROUTE;
  }

  const userStatus = String(userData?.userStatus || "").toLowerCase();
  if (userStatus !== "active") return "/user-deactivated";

  return "/dashboard";
};

export const resolvePostOtpRouteWithAccess = async (
  userData,
  postLoginRedirectRoute = "",
  permissionsPayload = null,
) => {
  const route = resolvePostOtpRoute(userData, postLoginRedirectRoute);

  if (route !== "/dashboard") {
    return route;
  }

  const checkPolicyRole = hasPolicyRoleFromPermissions(permissionsPayload);

  if (checkPolicyRole("VIEWER")) {
    return route;
  }

  const hasRoleAccess = canOpenNetworkMemberProfile({
    userDetails: userData,
    isSuperAdmin: hasSuperUserPermission(permissionsPayload),
    hasPolicyRole: checkPolicyRole,
  });

  if (hasRoleAccess) {
    return route;
  }

  const isNecCouncilMember = await fetchIsNecCouncilMember();
  return isNecCouncilMember ? route : ACCESS_DENIED_ROUTE;
};
